<template>
  <span
    v-if="customText.format === 'Un-Styled'"
    v-html="customText.content"
  ></span>
  <p v-else :class="textClasses" v-html="customText.content"></p>
</template>

<script>
  export default {
    props: ['customText'],
    computed: {
      textClasses() {
        const styles = {
          Subhead: 'p--subhead',
          Eyebrow: 'p--xs-eyebrow p--xs tracking-wide font-medium',
          'Paragraph Large': 'p--large',
          'Fine Print': 'p--fine-print',
          'Stat Figure': 'p--stat-figure',
          'Stat Text': 'p--stat-text',
          'Giant Stat': 'p--giant-stat',
          'Arrows List': 'ul--arrows-list'
        };
        return styles[this.$props.customText.format];
      }
    }
  };
</script>
